/**
 * Created by luissalcedo on 2/12/17.
 */


export const ionicConfig = {
  host: "https://call.srvpls.com",
  port: "",
  iniURL: "",
};



// WEBPACK FOOTER //
// ./src/environments/ionic2.config.ts